import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/external-systems',
    name: 'ExternalSystems',
    component: () => import('./components/layout.vue'),
    meta: {
      title: '外部系统',
    },
    children: [
      {
        path: 'template-and-pattern-select',
        name: 'ExternalSystemsTemplateAndPatternSelect',
        component: () => import('./template-and-pattern-select/index.vue'),
        meta: {
          title: '模板与图案选择',
          auth: true,
          isKeepAlive: false,
        },
      },
    ],
  },
] as IRouteConfig[];
